import React, { useState, useEffect } from "react";
import { array, func, bool, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import More from "../../atoms/More";
import CustomStoryCard9 from "../../molecules/CustomStoryCard9";
import DfpAd from "../../dfp-ad";
import Dialogue from "../../atoms/Dialogue";
import RightArrow from "../../atoms/icons/right-arrow";
import Calendar from "../../widgets/Calendar";
import FilterNavigation from "../../widgets/FilterNavigation";

import { staticTexts } from "../../utils/Translate";
import { dialogueShow } from "../../helper/actions";
import { isValidURL, sectionPageDfpAd } from "../../utils/utils";

import "./stories2AdWithLoadMore.m.css";

const TransparentOverlay = () => {
  return <div styleName="transparent-overlay"></div>;
};

const Stories2AdWithLoadMore = ({
  list = [],
  onLoadMore = null,
  isMoreStories = false,
  loading = false,
  isBorderTop = false,
  isNotification = false,
  publisherAttributes,
  widgetUrl,
  dialogueShow,
  isDialogue,
  widgetHeight,
  sectionsDataForHeader,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [showButtonSpinner, setButtonSpinner] = useState(false);

  useEffect(() => {
    setIsMobile(global.deviceWidth < 876);
    setIsDesktop(global.deviceWidth > 1263);

    if (!loading) {
      setButtonSpinner(false);
    }
  }, [loading]);
  const storyList = [...list]; // Make a copy of it to avoid changing of list
  const remainingStories = storyList.splice(0, storyList.length); // After Advertisement

  const handleButtonClick = (e) => {
    setButtonSpinner(true);
    onLoadMore(e);
  };

  let storyIndex = 0;

  const MoreComponent = (
    <div styleName={`load-more-view ${publisherAttributes.lang === "en" ? "en-load-more-view" : ""}`}>
      <More
        type="load-more"
        text={staticTexts(publisherAttributes.lang).more}
        onClick={handleButtonClick}
        showButtonSpinner={showButtonSpinner}
      />
    </div>
  );

  const calendarDialog = () => {
    dialogueShow(true);
  };

  const calendarMobile = () => {
    return (
      <>
        {isDialogue && (
          <Dialogue>
            <Calendar isMobile={true} />
          </Dialogue>
        )}
        <div styleName="day-fix-container">
          <div styleName="day-fix" onClick={calendarDialog}>
            <span styleName="day-fix-title">তারিখ</span>
            <span styleName="arrow-down">
              <RightArrow />
            </span>
          </div>
        </div>
      </>
    );
  };

  const widgetUrlCheckRender = () => {
    if (widgetUrl === "calendar") {
      return !isMobile ? <Calendar isMobile={false} /> : calendarMobile();
    } else if (widgetUrl === "filterNavigation" && widgetHeight) {
      return (
        <FilterNavigation
          sectionsDataForHeader={sectionsDataForHeader}
          widgetUrl={widgetUrl}
          widgetHeight={widgetHeight}
        />
      );
    } else if (isValidURL(widgetUrl)) {
      return <iframe src={widgetUrl} styleName="widget-iframe" height={widgetHeight}></iframe>;
    }
  };

  return (
    <>
      {showButtonSpinner && <TransparentOverlay />}
      <div styleName="wrapper" className="two-stories-with-load-more-wrapper">
        <div styleName={`${isDesktop ? "left-widget-container" : "mobile-widget-container"}`}>
          {widgetUrl && widgetUrlCheckRender()}
        </div>
        <div className="stories-set">
          {remainingStories.length > 0 ? (
            remainingStories.map((story, index) => {
              if (index > 19 && storyIndex === 20) {
                storyIndex = 1;
              } else if (index > 19) {
                storyIndex = storyIndex + 1;
              }
              return (
                <div key={index}>
                  {isMobile && (index === 5 || index === 10 || index === 15 || storyIndex === 1 || storyIndex === 11) && (
                    <div styleName="ad-wrapper">
                      <div styleName="ad-slot">
                        <DfpAd
                          adtype={sectionPageDfpAd(isMobile, index < 19 ? index : storyIndex)}
                          slotId={`Stories2AdWithLoadMore-firstAd-${index}`}
                        />
                      </div>
                    </div>
                  )}
                  {!isMobile && (index === 5 || index === 12 || storyIndex === 1 || storyIndex === 11) && (
                    <div styleName="ad-wrapper">
                      <div styleName="ad-slot">
                        <DfpAd
                          adtype={sectionPageDfpAd(isMobile, index < 19 ? index : storyIndex)}
                          slotId={`Stories2AdWithLoadMore-firstAd-${index}`}
                        />
                      </div>
                    </div>
                  )}
                  <CustomStoryCard9
                    story={story}
                    aspectRatio={isMobile ? [4, 3] : [3, 2]}
                    imageType={isMobile ? "image4x3" : "image3x2"}
                    isNotification={isNotification}
                    publisherLang={publisherAttributes.lang}
                    src="stories-2-ad-with-load-more"
                    updatedFont={true}
                    langClass={`${publisherAttributes.lang}-story-card`}
                    widths={global.deviceWidth < 876 ? [150] : [200]}
                  />
                </div>
              );
            })
          ) : (
            <div styleName="no-section-stories bn-no-stories">No stories found for this section !!</div>
          )}

          {isMoreStories ? MoreComponent : null}
        </div>
        {!isMobile && (
          <div>
            <div styleName="side-ad" className="side-ad">
              <DfpAd adtype={"News_336x280_R1"} slotId="Stories2AdWithLoadMore-sideAd" />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

Stories2AdWithLoadMore.propTypes = {
  list: array,
  onLoadMore: func,
  setLoading: func,
  loading: bool,
  isMoreStories: bool,
  isBorderTop: bool,
  isNotification: bool,
  publisherAttributes: object,
  widgetUrl: string,
  dialogueShow: func,
  isDialogue: bool,
  widgetHeight: string,
  sectionsDataForHeader: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  isDialogue: state.isDialogue,
});

const mapDispatchToProps = (dispatch) => ({
  dialogueShow: (show) => dispatch(dialogueShow(show)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Stories2AdWithLoadMore);
